export const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());

export const isValidPhone = (value) => {
    const normalized = String(value || "").trim();
    const digits = normalized.replace(/\D/g, "");

    return /^[+]?[(\d][\d\s().-]*(?:\s*(?:ext\.?|x)\s*\d+)?$/i.test(normalized)
        && digits.length >= 10
        && digits.length <= 15;
};

export const isValidWebsite = (value) => {
    try {
        const url = new URL(String(value || "").trim());
        return ["http:", "https:"].includes(url.protocol) && Boolean(url.hostname);
    } catch {
        return false;
    }
};

export const isValidPostalCode = (value) => {
    const normalized = String(value || "").trim();
    const canada = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    const usa = /^\d{5}(?:-\d{4})?$/;

    return canada.test(normalized) || usa.test(normalized);
};

export const isValidAddress = (value) => {
    const normalized = String(value || "").trim();
    return normalized.length >= 5 && /[A-Za-z]/.test(normalized) && /\d/.test(normalized);
};

export const exceedsWordLimit = (value, limit = 500) =>
    String(value || "").trim().split(/\s+/).filter(Boolean).length > limit;
